import { DataTable } from "@/src/components/ui/data-table";
import { useEffect, useState } from "react";
import { yachtsColumns } from "./yachtsColumns";
import { usePageChange, usePageSize, useSorting } from "./state";
import { Yacht } from "./model";
import qs from "qs";
import { useYachtsStore } from "../../stores/yachtsStore";
import { useEmit } from "../../lib/actions";
import { YachtDetailsModal } from "../Offers/EditOffer/YachtDetailsModal";
import { useOldSearch } from "../Offers/EditOffer/useOldSearch";

type SearchPagination = { totalCount: number; page: number; rowsPerPage: number };

type YachtsData = {
  data: Yacht[];
} & SearchPagination;

export function YachtsTable() {
  const [loading, setLoading] = useState(false);
  const [yachtId, setYachtId] = useState<Yacht["id"] | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [yachts, setYachts] = useState<YachtsData>({
    data: [],
    totalCount: 1,
    page: 1,
    rowsPerPage: 40,
  });
  const pageSize = usePageSize();
  const page = usePageChange();
  const sort = useSorting();
  const { filters } = useYachtsStore();
  const emit = useEmit<number>("ych:page");

  const query = qs.stringify(filters, { indices: false });
  const sortQuery = sort === "recommended" ? "" : `&sort=${sort}`;

  const { search: fetchYachts } = useOldSearch();

  useEffect(() => {
    setLoading(true);
    fetchYachts(`?page=${page}&mode=all&rowsPerPage=${pageSize}&${query}${sortQuery}`).then((data) => {
      setYachts(data);
      setLoading(false);
    });
  }, [page, pageSize, query, sort]);

  const openModal = (yacht: Yacht) => {
    setYachtId(yacht.id);
    setModalOpen(true);
  };

  return (
    <div className="rounded-md bg-white border overflow-hidden">
      <DataTable
        columns={yachtsColumns}
        data={yachts.data}
        isLoading={loading}
        pagination={{
          pagination: {
            page: yachts.page,
            pageSize: yachts.rowsPerPage,
          },
          total: yachts.totalCount,
        }}
        onRowClick={openModal}
        onPageClick={(page) => {
          emit(page);
        }}
      />
      {modalOpen && <YachtDetailsModal yachtDetailsId={yachtId} open={modalOpen} setOpen={setModalOpen} />}
    </div>
  );
}
